export default __webpack_public_path__ + "static/media/cheatday_2@2x.f836179e.jpg";